import { usePeriodDates } from './usePeriodDates';
import { formatDate, DateFormat } from '../util/casMoment';

export function usePeriodStartDateMonthYear() {
  const { data, isLoading } = usePeriodDates();

  const formattedDate = formatDate(data?.currentPeriodStart, DateFormat.MMMMY);

  return { periodStartDate: formattedDate, isLoading };
}
